(function() {
  function groupCardsByRow(cards) {
    var rows = {};
    cards.forEach(function(card) {
      var top = Math.round(card.getBoundingClientRect().top);
      var rowKey = null;
      var keys = Object.keys(rows);
      for (var i = 0; i < keys.length; i++) {
        if (Math.abs(parseInt(keys[i]) - top) < 5) {
          rowKey = keys[i];
          break;
        }
      }
      if (rowKey === null) rowKey = top;
      if (!rows[rowKey]) rows[rowKey] = [];
      rows[rowKey].push(card);
    });
    return rows;
  }

  function equalizeElements(selector, getCard) {
    var elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    // Reset
    elements.forEach(function(el) { el.style.minHeight = ''; });

    // Group by row using parent card position
    var rows = {};
    elements.forEach(function(el) {
      var card = getCard(el);
      if (!card) return;
      var top = Math.round(card.getBoundingClientRect().top);
      var rowKey = null;
      var keys = Object.keys(rows);
      for (var i = 0; i < keys.length; i++) {
        if (Math.abs(parseInt(keys[i]) - top) < 5) {
          rowKey = keys[i];
          break;
        }
      }
      if (rowKey === null) rowKey = top;
      if (!rows[rowKey]) rows[rowKey] = [];
      rows[rowKey].push(el);
    });

    // Equalize per row
    Object.keys(rows).forEach(function(key) {
      var rowEls = rows[key];
      if (rowEls.length <= 1) return;
      var maxHeight = 0;
      rowEls.forEach(function(el) {
        var h = el.getBoundingClientRect().height;
        if (h > maxHeight) maxHeight = h;
      });
      rowEls.forEach(function(el) {
        el.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function getCard(el) {
    return el.closest('product-card') || el.closest('.product-card');
  }

  function equalizeOnePerCard(selector, getCard) {
    // For each card, find first matching element only
    var cards = document.querySelectorAll('product-card');
    if (!cards.length) cards = document.querySelectorAll('.product-card');
    if (!cards.length) return;

    var pairs = [];
    cards.forEach(function(card) {
      var el = card.querySelector(selector);
      if (el) {
        el.style.minHeight = '';
        pairs.push({ card: card, el: el });
      }
    });

    // Group by row
    var rows = {};
    pairs.forEach(function(pair) {
      var top = Math.round(pair.card.getBoundingClientRect().top);
      var rowKey = null;
      var keys = Object.keys(rows);
      for (var i = 0; i < keys.length; i++) {
        if (Math.abs(parseInt(keys[i]) - top) < 5) {
          rowKey = keys[i];
          break;
        }
      }
      if (rowKey === null) rowKey = top;
      if (!rows[rowKey]) rows[rowKey] = [];
      rows[rowKey].push(pair);
    });

    Object.keys(rows).forEach(function(key) {
      var rowPairs = rows[key];
      if (rowPairs.length <= 1) return;
      var maxHeight = 0;
      rowPairs.forEach(function(p) {
        var h = p.el.getBoundingClientRect().height;
        if (h > maxHeight) maxHeight = h;
      });
      rowPairs.forEach(function(p) {
        p.el.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function equalizeAll() {
    // 1. Equalize title heights
    equalizeElements('.product-card .product-card_title', getCard);
    // 2. After reflow, equalize entire .product-price block
    requestAnimationFrame(function() {
      equalizeElements('.product-card .product-price', getCard);
      requestAnimationFrame(function() {
        // 3. Equalize first child of .product-price (vat-container or pg-product-price-vat-exclude)
        // so "bez DPH" and availability align across regular, sale, and sold-out cards
        equalizeOnePerCard('.product-price > :first-child', getCard);
      });
    });
  }

  // Run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(equalizeAll, 100);
    });
  } else {
    setTimeout(equalizeAll, 100);
  }

  // Run after all images loaded
  window.addEventListener('load', equalizeAll);

  // Run on resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 150);
  });

  // Re-run after AJAX content loads (infinite scroll, filters)
  var observer = new MutationObserver(function(mutations) {
    var shouldRun = false;
    mutations.forEach(function(m) {
      if (m.addedNodes.length) {
        for (var i = 0; i < m.addedNodes.length; i++) {
          if (m.addedNodes[i].nodeType === 1 &&
              (m.addedNodes[i].tagName === 'PRODUCT-CARD' ||
               m.addedNodes[i].querySelector && m.addedNodes[i].querySelector('product-card'))) {
            shouldRun = true;
          }
        }
      }
    });
    if (shouldRun) {
      setTimeout(equalizeAll, 100);
    }
  });

  var grid = document.querySelector('#main-collection-product-grid');
  if (grid) {
    observer.observe(grid, { childList: true, subtree: true });

  }

})();
